import * as $ from "jquery";
import "../../lib/jquery.magnific-popup.js";

export function init() {

	$('body').magnificPopup({
		delegate: ".js-video",
		type: 'iframe',
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
			'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

			patterns: {
				youtube: {
					index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

					id: 'v=', // String that splits URL in a two parts, second part should be %id%
					// Or null - full URL will be returned
					// Or a function that should return %id%, for example:
					// id: function(url) { return 'parsed id'; }

					src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&modestbranding=1&showinfo=0' // URL that will be set as a source for iframe.
				}
			},

			srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
		},
		mainClass: 'modal-zoom'
	});

	$('.js-grouping').each(function(){
		var $items = $(this).find('.image-zoom');
		var $tallItems = $items.parents('.image-grid__item--tall').find('.image-zoom');

		var $itemsGrouped = [];

		$items.each(function(){
			var theID = $(this).data('ids');
			$itemsGrouped.push(theID);
		});

		//fix bug with object-fit on 100% items
		function setHeightOnTallItems(){
			$tallItems.each(function(){
				$(this).css('height', $(this).height());
			});
		}

		setHeightOnTallItems();

		$('window').on('resize', function(){
			setHeightOnTallItems();
		});

		var groupedIDs = $itemsGrouped.join(',');
		$(this).attr('data-grouped-ids', groupedIDs);
	});

	/*
	$('.js-click-to-zoom').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		image: {
			markup: '<div class="mfp-figure">'+
			'<div class="mfp-close"></div>'+
			'<div class="mfp-img"></div>'+
			'<div class="mfp-bottom-bar">'+
			'<div class="mfp-title"></div>'+
			'<div class="mfp-counter"></div>'+
			'</div>'+
			'</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

			cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

			titleSrc: 'title', // Attribute of the target element that contains caption for the slide.
			// Or the function that should return the title. For example:
			// titleSrc: function(item) {
			//   return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
			// }

			verticalFit: true, // Fits image in area vertically

			tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
		},
		mainClass: 'modal-zoom'
	});
	*/

	$('.js-product-media-link').each(function () {
		var $this = $(this);
		$this.on('click', function (e) {
			var $href = $(this).attr('href');
			// console.log('The href link is: '+$href);

			e.preventDefault();
			$('body').addClass('iframe-products');

			$.magnificPopup.open({
				items: {
					//if its a single ID and pass a query string param indicating so
					//also if its inside of an image grid pass the selected id through to the modal so we can set it when the carousel loads
					src: $href
				},
				iframe: {
					markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" scrolling="no" frameborder="0" allowfullscreen></iframe>'+
					'</div>'
				},
				type: 'iframe',
				callbacks: {
					markupParse: function(template, values, item) {
						template.find('iframe').addClass('scene7-iframe');
					},
					close: function() {
						$('body').removeClass('iframe-products');
					}
				},
				mainClass: 'modal-zoom'
			});
		});
	});

	$('.js-inline-modal').each(function(){
		let $this = $(this);
		$this.on('click', function (e) {
			var $href = $(this).attr('href');
			e.preventDefault();

			$.magnificPopup.open({
				items: {
					src: $href
				},
				type:'inline',
				midClick: true,
				alignTop:false,
				closeBtnInside: true,
				mainClass: 'modal-zoom'
			});
		});
	});

	if($('.js-image-modal').length) {
		$('.js-image-modal').magnificPopup({
			type: 'image',
			mainClass: 'modal-zoom',
			midClick: true,
			alignTop:false,
			closeBtnInside: true
		});
	}

	$('body').on('click', '.js-modal', function(e) {
		var $href = $(this).attr('href');
		e.preventDefault();
		$('body').addClass('iframe-general');

		$.magnificPopup.open({
			items: {
				src: $href
			},
			iframe: {
				markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" scrolling="no" frameborder="0" allowfullscreen></iframe>'+
					'</div>'
			},
			type: 'iframe',
			callbacks: {
				markupParse: function(template, values, item) {
					template.find('iframe').addClass('general-iframe');
				},
				close: function() {
					$('body').removeClass('iframe-general');
				}
			},
			mainClass: 'modal-zoom'
		});
	})

	initProductModals();
}

export function initProductModals() {
	$('.js-product-modal').each(function() {
		let $this = $(this);
		let parentIds = $this.parents('.js-grouping').data('grouped-ids');
		let ids = $this.parents('.js-grouping').length ? parentIds : $this.data('ids');
		let $arrayValues = $.param({ids});
		let $finalUrl = "?" + $arrayValues;
		let itemsLength = ids.indexOf(',') != -1 ? ids.split(',').length : 1;
		let clickedItemID = $this.data('ids');

		let finalUrl = $finalUrl + (itemsLength == 1 ? "&singleImage=true" : ($this.parents('.js-grouping').length ? "&selectedItem="+clickedItemID : "") );

		$this.attr('href', "/modal"+finalUrl);
	});

	$('.js-product-modal').each(function () {
		var $this = $(this);
		$this.on('click', function (e) {
			// var $href = $(this).attr('href');
			// var parentIds = $(this).parents('.js-grouping').data('grouped-ids');
			// var ids = $this.parents('.js-grouping').length ? parentIds : $(this).data('ids');
			// var $arrayValues = $.param({ids});
			// var $finalUrl = $href + "?" + $arrayValues;
			// var itemsLength = ids.indexOf(',') != -1 ? ids.split(',').length : 1;
			// var clickedItemID = $(this).data('ids');

			// console.log($this.attr('href'));

			$('body').addClass('iframe-products');

			e.preventDefault();

			$.magnificPopup.open({
				items: {
					//if its a single ID and pass a query string param indicating so
					//also if its inside of an image grid pass the selected id through to the modal so we can set it when the carousel loads
					// src: $finalUrl + (itemsLength == 1 ? "&singleImage=true" : ($this.parents('.js-grouping').length ? "&selectedItem="+clickedItemID : "") )
					src: $this.attr('href')
				},
				iframe: {
					markup: '<div class="mfp-iframe-scaler">'+
						'<div class="mfp-close"></div>'+
						'<iframe class="mfp-iframe" scrolling="no" frameborder="0" allowfullscreen></iframe>'+
						'</div>'
				},
				type: 'iframe',
				callbacks: {
					markupParse: function(template, values, item) {
						template.find('iframe').addClass('scene7-iframe');
					}
				},
				mainClass: 'modal-zoom'
			});
		});
	});
}



// WEBPACK FOOTER //
// ./js/PFF/modules/modals.ts